module.exports = __webpack_public_path__ + "static/img/PK10.abac23b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK10.jpg
// module id = ZlsK
// module chunks = 0